const camelToSnakeCase = (value) =>
  value.replace(/[A-Z]/g, (letter) => `_${letter.toLowerCase()}`);

export const string = {
  camelToSnakeCase,
};



// WEBPACK FOOTER //
// ./src/_shared/utils/string.js